import React from "react";
import AboutDiksha from "./AboutDiksha";
import Testimonial from "./Testimonial";
import WhyChoose from "./WhyChoose";
import { Link } from "react-router-dom";

const Home = () => {
  // ===================== POPUP STATE =====================
  const [showPopup, setShowPopup] = React.useState(false);

  React.useEffect(() => {
    setShowPopup(true); // popup opens automatically when page loads
  }, []);

  // ===================== SLIDER CODE =====================
  const [current, setCurrent] = React.useState(0);

  const images = [
    "../../img/banner1.png",
    "../../img/banner2.png",
    "../../img/banner3.png",
  ];

  const imageSlides = document.getElementsByClassName("slide-image");
  const bubbles = document.getElementsByClassName("bubble-outer");

  const nextImage = () => {
    let newIndex = current === images.length - 1 ? 0 : current + 1;
    imageSlides[current].className = "slide-image leftOut";
    imageSlides[newIndex].className = "slide-image leftIn";
    updateBubbles(newIndex);
    setCurrent(newIndex);
  };

  const prevImage = () => {
    let newIndex = current === 0 ? images.length - 1 : current - 1;
    imageSlides[current].className = "slide-image rightOut";
    imageSlides[newIndex].className = "slide-image rightIn";
    updateBubbles(newIndex);
    setCurrent(newIndex);
  };

  const jumpImage = (e) => {
    let jumpIndex = parseInt(e.target.id);
    if (jumpIndex === current) return;

    if (jumpIndex - current >= 0) {
      imageSlides[current].className = "slide-image leftOut";
      imageSlides[jumpIndex].className = "slide-image leftIn";
    } else {
      imageSlides[current].className = "slide-image rightOut";
      imageSlides[jumpIndex].className = "slide-image rightIn";
    }

    updateBubbles(jumpIndex);
    setCurrent(jumpIndex);
  };

  const updateBubbles = (highlight) => {
    bubbles[current].style.borderColor = "black";
    bubbles[highlight].style.borderColor = "white";
  };

  React.useEffect(() => {
    bubbles[current].style.borderColor = "white";
  }, []);

  // ========================== UI RETURN ==========================
  return (
    <div>
      {/* =================== POPUP =================== */}
      {showPopup && (
        <div
  style={{
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    zIndex: 9999,
  }}
  onClick={() => setShowPopup(false)}
>
  <div
    style={{
      background: "#fff",
      padding: "10px",
      borderRadius: "10px",
      maxWidth: "400px",
      width: "100%",
      position: "relative",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    }}
    onClick={(e) => e.stopPropagation()}
  >
    {/* Close Button */}
    <button
      onClick={() => setShowPopup(false)}
      style={{
        position: "absolute",
        top: "6px",
        right: "8px",
        fontSize: "18px",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#555",
      }}
    >
      ✕
    </button>

    {/* Popup Image */}
    <img
      src="/aiimagepopup.jpeg"
      alt="Popup"
      style={{
        width: "100%",
        borderRadius: "8px",
        display: "block",
      }}
    />
  </div>
</div>

      )}

      {/* =================== PAGE CONTENT =================== */}
      <div className="container-fluid p-0 mt-5">
        <div className="gallery-container">
          <span className="button-prev" onClick={prevImage}>
            chevron_left
          </span>
          <span className="button-next" onClick={nextImage}>
            chevron_right
          </span>

          <div className="gallery-track">
            {images.map((image, index) => (
              <div
                key={index}
                className="slide-image"
                style={
                  index === 0
                    ? {
                        backgroundImage: `url(${image})`,
                        transform: "translateX(0%)",
                      }
                    : {
                        backgroundImage: `url(${image})`,
                        transform: "translateX(100%)",
                      }
                }
              ></div>
            ))}
          </div>

          <div className="gallery-footer">
            {images.map((_, index) => (
              <div
                key={index}
                className="bubble-outer"
                onClick={jumpImage}
                id={index}
              >
                <div className="bubble-inner" id={index}></div>
              </div>
            ))}
          </div>
        </div>

        <AboutDiksha />

        {/* ===== Services Section ===== */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-4">
              {/* Skilled Instructors */}
              <div
                className="col-lg-3 col-sm-6"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp",
                  animationFillMode: "both",
                  animationDuration: "1s",
                }}
              >
                <div className="service-item text-center pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-graduation-cap text-primary mb-4"></i>
                    <h5 className="mb-3">Skilled Instructors</h5>
                    <p>
                      Learn from industry experts with years of experience,
                      committed to mentoring and guiding you.
                    </p>
                  </div>
                </div>
              </div>

              {/* Online Classes */}
              <div
                className="col-lg-3 col-sm-6"
                style={{
                  visibility: "visible",
                  animationDelay: "0.3s",
                  animationName: "fadeInUp",
                  animationFillMode: "both",
                  animationDuration: "1s",
                }}
              >
                <div className="service-item text-center pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-globe text-primary mb-4"></i>
                    <h5 className="mb-3">Online Classes</h5>
                    <p>
                      Access interactive live sessions and self-paced courses
                      designed for flexibility.
                    </p>
                  </div>
                </div>
              </div>

              {/* Projects */}
              <div
                className="col-lg-3 col-sm-6"
                style={{
                  visibility: "visible",
                  animationDelay: "0.5s",
                  animationName: "fadeInUp",
                  animationFillMode: "both",
                  animationDuration: "1s",
                }}
              >
                <div className="service-item text-center pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-home text-primary mb-4"></i>
                    <h5 className="mb-3">Real-World Projects</h5>
                    <p>
                      Work on real-world projects that help build strong
                      industry-ready skills.
                    </p>
                  </div>
                </div>
              </div>

              {/* Library */}
              <div
                className="col-lg-3 col-sm-6"
                style={{
                  visibility: "visible",
                  animationDelay: "0.7s",
                  animationName: "fadeInUp",
                  animationFillMode: "both",
                  animationDuration: "1s",
                }}
              >
                <div className="service-item text-center pt-3">
                  <div className="p-4">
                    <i className="fa fa-3x fa-book text-primary mb-4"></i>
                    <h5 className="mb-3">Learning Support</h5>
                    <p>
                      Benefit from one-on-one guidance and dedicated support
                      throughout your journey.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <WhyChoose />

      {/* Hero Section */}
      <div
        className="hero-section"
        style={{
          backgroundImage: "url(img/hero-bg.jpg)",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h1
          className="bg-white text-center text-primary px-3"
          style={{ fontSize: "30px" }}
        >
          Empower Your Career with Industry-Leading IT Training
        </h1>
        <p>Gain skills for a brighter future.</p>
        <Link to="/courses">Explore Courses</Link>
      </div>

      {/* Popular Courses */}
      <div className="container py-5">
        <h2 className="text-center mb-4">Our Most Popular Courses</h2>
        <div className="row">
          {[
            {
              title: "Full-Stack Development",
              description: "Become a MERN stack developer.",
              image: "img/courses/java_fullstack.jpg",
              link: "/coursedetails?name=javafullstack",
            },
            {
              title: "Cloud Computing",
              description: "Master AWS & Azure.",
              image: "img/courses/cloud_technology.jpg",
              link: "/coursedetails?name=cloudtechnology",
            },
            {
              title: "DevOps",
              description: "Learn CI/CD pipelines & automation.",
              image: "img/courses/devops.jpg",
              link: "/coursedetails?name=devops",
            },
          ].map((course, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <div className="card">
                <img src={course.image} className="card-img-top" alt={course.title} />
                <div className="card-body">
                  <h5 className="card-title">{course.title}</h5>
                  <p className="card-text">{course.description}</p>
                  <Link to={course.link} className="btn btn-primary">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Difference Section */}
      <div className="container py-5">
        <div className="text-center">
          <h1
            className="section-title bg-white text-start text-primary pe-3"
            style={{ fontSize: "1.2rem" }}
          >
            How We Are Different
          </h1>
        </div>

        <div className="row">
          {/* Column 1 */}
          <div className="col-md-6">
            <ul
              className="list-unstyled"
              style={{ fontSize: "1.2rem", lineHeight: "1.8" }}
            >
              <li>✔ Database of hiring companies.</li>
              <li>✔ Certificates after successful completion.</li>
              <li>✔ 50+ years combined teaching experience.</li>
            </ul>
          </div>

          {/* Column 2 */}
          <div className="col-md-6">
            <ul
              className="list-unstyled"
              style={{ fontSize: "1.2rem", lineHeight: "1.8" }}
            >
              <li>✔ #1 Training institute in Tirupati.</li>
              <li>✔ Real-time project-based teaching.</li>
              <li>✔ Career & placement support.</li>
            </ul>
          </div>
        </div>
      </div>

      <Testimonial />
    </div>
  );
};

export default Home;
